/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';

const SubscriptionTypeIsNotArchived = BaseValidator.extend({
  validate(subscriptionTypeId, options, model) {
    if (model.subscriptionType?.isArchived) {
      return "You can't use an archived subscription type";
    }

    return true;
  },
});

SubscriptionTypeIsNotArchived.reopenClass({
  getDependentsFor() {
    return ['model.subscriptionType.state'];
  },
});

export default SubscriptionTypeIsNotArchived;
